import { connect } from 'react-redux'
import ArchivedInvitations from './archived-invitations'
import { fetchArchivedInvitations } from '../../../../stores/archived-invitations/archived-invitations.actions'
import {
  getFetchInvitationsRequest,
  getInvitations,
  getPagination
} from '../../../../stores/archived-invitations/archived-invitations.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const fetchInvitationsRequest = getFetchInvitationsRequest(state)
  const invitations = getInvitations(state)
  return {
    noInvitations: invitations && !invitations.result.length,
    pending: !invitations || fetchInvitationsRequest.pending,
    pagination: getPagination(state)
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => {
    return dispatch(fetchArchivedInvitations())
  },
  onPageChange: ({ selected }) =>
    dispatch(fetchArchivedInvitations({ page: selected })).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArchivedInvitations)
